export default __webpack_public_path__ + "static/media/categories.7055dd4a.svg";